import styled, { css } from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

const centeredColumnsContainer = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 8px 4px 8px 8px;

  border-radius: ${({ theme }) => theme.zds.border.radius100};
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  overflow: auto;

  ${VerticalStyledScrollBar}
`

export const List = styled.ul`
  ${centeredColumnsContainer}
  position: relative;
  width: 100%;
  height: 100%;
  gap: 8px;
`

export const LoadingContainer = styled.div`
  ${centeredColumnsContainer}
  height: 100%;
  justify-content: center;
`
